module.exports = __webpack_public_path__ + "img/accessory_pants_02.3435dc42.svg";